// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"cdf00ee8","702":"90af1377","897":"43fdd8bf","934":"7d0f4ef5"}[chunkId] + ".chunk.js";
};